import styles from "./styles.module.scss";
import Sorter from "./Sorter";
import RenderFilters from "./RenderFilters";
import FilterByDate from "./FilterByDate";

const FilterSort = () => {
  return (
    <div className={styles.filterWrapper}>
      <Sorter />
      <RenderFilters title={"Filter by tag"} field={"tags"} prefix={"tag"} />
      <FilterByDate title={"Filter by upload date"} field={"upload_date"} />
    </div>
  );
};
export default FilterSort;
